import { Bold, Italic, List, Heading2 } from 'lucide-react';

export default function MarkdownToolbar({ textareaRef, onInsert }) {
  const insertMarkdown = (before, after = '', placeholder = 'text') => {
    const textarea = textareaRef.current;
    if (!textarea) return;

    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const selectedText = textarea.value.substring(start, end);
    const textToInsert = selectedText || placeholder;
    
    const newText = 
      textarea.value.substring(0, start) +
      before + textToInsert + after +
      textarea.value.substring(end);
    
    onInsert(newText);
    
    // Set cursor position after insert
    setTimeout(() => {
      textarea.focus();
      const newCursorPos = start + before.length + textToInsert.length;
      textarea.setSelectionRange(newCursorPos, newCursorPos);
    }, 0);
  };

  return (
    <div className="flex items-center gap-1 mb-2 p-2 bg-[#F7F6F2] rounded-lg border border-[#E1DFD7]">
      <div className="flex items-center gap-1">
        <button
          type="button"
          onClick={() => insertMarkdown('**', '**', 'bold text')}
          className="p-2 hover:bg-white rounded transition-colors"
          title="Bold (Ctrl+B)"
        >
          <Bold className="w-4 h-4 text-[#0B2240]" />
        </button>
        
        <button
          type="button"
          onClick={() => insertMarkdown('*', '*', 'italic text')}
          className="p-2 hover:bg-white rounded transition-colors"
          title="Italic (Ctrl+I)"
        >
          <Italic className="w-4 h-4 text-[#0B2240]" />
        </button>
        
        <button
          type="button"
          onClick={() => {
            const textarea = textareaRef.current;
            const start = textarea.selectionStart;
            const lineStart = textarea.value.lastIndexOf('\n', start - 1) + 1;
            const newText = 
              textarea.value.substring(0, lineStart) +
              '- ' +
              textarea.value.substring(lineStart);
            onInsert(newText);
          }}
          className="p-2 hover:bg-white rounded transition-colors"
          title="Bullet List"
        >
          <List className="w-4 h-4 text-[#0B2240]" />
        </button>
        
        <button
          type="button"
          onClick={() => insertMarkdown('## ', '', 'Heading')}
          className="p-2 hover:bg-white rounded transition-colors"
          title="Heading"
        >
          <Heading2 className="w-4 h-4 text-[#0B2240]" />
        </button>
      </div>
      
      <div className="ml-auto text-xs text-[#4C5A70] bg-white px-3 py-1 rounded">
        <span className="font-medium">Markdown:</span> **bold** • *italic* • - bullet
      </div>
    </div>
  );
}
